<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">MBP-2  Register of Loans, guarantee, Security and acquisition made by the company</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/mbp2/add"> -->
        <button (click)="add()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" [appHasPermission]="{'Url': '/register/mbp2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp2List'}">
          <i class="fa fa-plus"></i>&nbsp;Add</button>
      <!-- </a> -->
    </span> 
    <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
  </div>

  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span>
    </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-3">
              <label>Client ID / DP No</label>
              <input type="text" class="form-control" [(ngModel)]="clientIdDPno">
            </div>

            <div class="col-md-3">
            <label>Nature of transaction</label>
              <select class="form-control" style="padding:6px;" [(ngModel)]="natureOfTransaction" >
                <option value='' selected='true'>Select Transaction Type</option>
                <option name="Loan" value="loan">Loan</option>
                <option value="G/s">Guarantee / Security</option>
                <option value="investment">Investment / Acquisition</option>
              </select>
            </div>

            <div class="col-md-3">
              <br>
              <!-- <label>Date of Loan</label> -->
              <div class="input-group" (click)="$event.stopPropagation()">
                
                From:&nbsp;
                <input id="dateLoan" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateLoan" ngbDatepicker
                  #cesDate="ngbDatepicker" (click)="cesDate.toggle();b.close()" [(ngModel)]="dateLoan">
                <button class="input-group-addon" (click)="cesDate.toggle();b.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>

            <div class="col-md-3">
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
                 To:&nbsp;
                <input id="dateLoanTo" class="form-control" [minDate]="futureToDateTo"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateLoanTo" ngbDatepicker
                #b="ngbDatepicker" (click)="b.toggle();cesDate.close()" [(ngModel)]="dateLoanTo">
              <button class="input-group-addon" (click)="b.toggle();;cesDate.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div>



           


           




             <!-- <div class="col-md-4">
              <br><br>
              <label>Date of Guarantee / Security</label>dateOfGuarantee
              <div class="input-group" (click)="$event.stopPropagation()">
                From:&nbsp;
                <input id="dateOfGuarantee" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfGuarantee" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfGuarantee">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                &nbsp;&nbsp; To:&nbsp;
                <input id="dateOfGuaranteeTo" class="form-control" [minDate]="futureToDateTo"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfGuaranteeTo" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfGuaranteeTo">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div> -->


            <!-- <div class="col-md-4">
              <br><br>
              <label>Date of Investment / Acquisition</label>
              <div class="input-group" (click)="$event.stopPropagation()">
                From:&nbsp;
                <input id="dateOfInvestment" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfInvestment" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfInvestment">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                &nbsp;&nbsp; To:&nbsp;
                <input id="dateOfInvestmentTo" class="form-control" [minDate]="futureToDateTo"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfInvestmentTo" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfInvestmentTo">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div> -->






            <!-- <div class="col-md-4">
              <label>Date of making loan / acquisition / giving guarantee / providing security
              </label>
              <div class="input-group" (click)="$event.stopPropagation()">
                <input id="dateOfMakingLoan" class="form-control" style="padding:6px;z-index: 0;"
                  placeholder="dd-mm-yyyy" name="dateOfMakingLoan" ngbDatepicker #cesDate="ngbDatepicker"
                  (click)="cesDate.toggle()" [(ngModel)]="dateOfMakingLoan">
                <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div> -->
          </div>
          
          <div class="row">
            <div class="col-md-3">
              <br>
              <label>Name of the person / body corporate to whom loan / security / investment / guarantee is made or
                whose securities have been acquired </label>
              <input type="text" class="form-control" [(ngModel)]="nameOfPerson">
              <br>
            </div>
            
           
            <div class="col-lg-2 col-md-2 col-sm-2">
              <br><br><br><br><br>
              <!-- <br><label>&nbsp;&nbsp;&nbsp;</label> -->
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
              class="table table-hover compact cell-border nowrap stripe" id="mbpmasterlistTable"
              style="cursor: pointer;">
              <thead>
                <tr>
                  <th>Nature of transaction</th>
                  <th>Amount of Loan /<br> Investment / Guarantee /<br> Security / Acquisition</th>
                  <th>Date of passing <br>Board resolution</th>
                  <th style="display: none">Date of passing Board resolution</th>
                  <th>Date of passing <br>special resolution</th>
                  <th style="display: none">Date of passing special resolution</th>

                  <th>Date of <br>Repayment</th>
                  <th style="display: none">Date of Repayment</th>

                  <th>Date of selling <br>of investment</th>
                  <th style="display: none">Date of selling of investment</th>

                  <th>Date of <br>Disposal</th>
                  <th style="display: none">Date of Disposal</th>

                  <th>Date of <br>Maturity </th>
                  <th style="display: none">Date of Maturity </th>

                  <th>Date of making loan / <br>investment / acquisition / <br>giving guarantee / <br>providing security</th>
                  <th style="display: none">Date of making loan / investment / acquisition / giving guarantee / providing security</th>

                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let director of registerDirectorList;let i=index">
                  <td tabindex="1">
                    <span *ngIf="director.natureOfTransaction=='loan'">Loan</span>
                    <span *ngIf="director.natureOfTransaction=='G/s'">Guarantee / Security</span>
                    <span *ngIf="director.natureOfTransaction=='investment'">Investment / Acquisition</span>
                  </td>
                  <td tabindex="1">
                    {{director.amount}}
                  </td>
                  <td>
                    <span style="display: none">{{director.dateOfPassingBoardResolution | date : "yMMdd"}}</span>
                    {{director.dateOfPassingBoardResolution | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfPassingBoardResolution | date : "dd-MM-y"}}
                  </td>
                  <td>
                    <span style="display: none">{{director.dateOfPassingResolutionIfRequired | date : "yMMdd"}}</span>
                    {{director.dateOfPassingResolutionIfRequired | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfPassingResolutionIfRequired | date : "dd-MM-y"}}
                  </td>



                  <td>
                    <span style="display: none">{{director.dateOfRepayment | date : "yMMdd"}}</span>
                    {{director.dateOfRepayment | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfRepayment | date : "dd-MM-y"}}
                  </td>


                  <td>
                    <span style="display: none">{{director.dateOfSellingOfInvestment | date : "yMMdd"}}</span>
                    {{director.dateOfSellingOfInvestment | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfSellingOfInvestment | date : "dd-MM-y"}}
                  </td>

                  <td>
                    <span style="display: none">{{director.dateOfDisposal | date : "yMMdd"}}</span>
                    {{director.dateOfDisposal | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfDisposal | date : "dd-MM-y"}}
                  </td>


                  <td>
                    <span style="display: none">{{director.dateOfMaturity | date : "yMMdd"}}</span>
                    {{director.dateOfMaturity | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfMaturity | date : "dd-MM-y"}}
                  </td>

                  <td>
                    <span style="display: none">{{director.dateOfMakingLoan | date : "yMMdd"}}</span>
                    {{director.dateOfMakingLoan | date : "dd-MM-y"}}
                  </td>
                  <td style="display: none">
                    {{director.dateOfMakingLoan | date : "dd-MM-y"}}
                  </td>



                  <td style='white-space: nowrap'>
                    <a>
                      <button type="button" (click)="editmbp(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mbp2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp2List'}">
                        <span class="fa fa-pencil"></span>
                      </button>
                    </a>
                    <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mbp2List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp2List'}">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="myModalLabelForDelete">
          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            Are you sure you want to delete MBP-2 details?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="deletembpdetail()">
          <i class="fa fa-check"></i>&nbsp;Yes
        </button>
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;No
        </button>
      </div>
    </div>
  </div>
</div>